import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landrecordform',
  templateUrl: './landrecordform.component.html',
  styleUrls: ['./landrecordform.component.css']
})
export class LandrecordformComponent implements OnInit {
title="Add Land Record"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/land-record/landrecordform/landrecordform.component.ts